import { c as _c } from "react/compiler-runtime";
import type { FormatoDaExportacao, SimulacaoChatPreviewProps } from '../types';
import { MIMES_ACEITOS_NO_ANEXO } from '../utils/anexoDaSimulacao';
import { LIMITE_DO_TEXTO } from '../utils/compositorDaSimulacao';
import { useAcessarArquivoDaSimulacao } from './useAcessarArquivoDaSimulacao';
import { useConversaDaSimulacao } from './useConversaDaSimulacao';
import { useEnviarAnexoDaSimulacao } from './useEnviarAnexoDaSimulacao';
import { useSimulacaoPolling } from './useSimulacaoPolling';

/**
 * A conversa da simulação como as duas telas a montam (a do cliente e a do admin): eventos,
 * envio, anexo, arquivos e polling. O celular recebe as mesmas props nas duas.
 */
export function useConversaNaTela(agentName) {
  const $ = _c(38);
  const conversa = useConversaDaSimulacao(agentName);
  const anexo = useEnviarAnexoDaSimulacao();
  const arquivos = useAcessarArquivoDaSimulacao();
  useSimulacaoPolling();
  let t0;
  if ($[0] !== anexo || $[1] !== conversa) {
    t0 = () => {
      anexo.descartarFalha();
      conversa.enviar();
    };
    $[0] = anexo;
    $[1] = conversa;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const handleSend = t0;
  let t1;
  if ($[3] !== anexo) {
    t1 = file => {
      anexo.enviar(file);
    };
    $[3] = anexo;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleAttach = t1;
  let t2;
  if ($[5] !== arquivos) {
    t2 = fileId => {
      arquivos.abrir(fileId);
    };
    $[5] = arquivos;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleOpenFile = t2;
  const t3 = anexo.status ?? conversa.composerStatus;
  const t4 = conversa.attachEnabled && !anexo.enviando;
  let t5;
  if ($[7] !== agentName || $[8] !== arquivos.indisponiveis || $[9] !== arquivos.marcarIndisponivel || $[10] !== arquivos.simulacaoId || $[11] !== arquivos.superficie || $[12] !== conversa.activeInteractionId || $[13] !== conversa.answeredMessageIds || $[14] !== conversa.cleared || $[15] !== conversa.draft || $[16] !== conversa.inputEnabled || $[17] !== conversa.messages || $[18] !== conversa.responder || $[19] !== conversa.sending || $[20] !== conversa.setDraft || $[21] !== conversa.situation || $[22] !== conversa.started || $[23] !== conversa.tentarNovamente || $[24] !== conversa.typing || $[25] !== handleAttach || $[26] !== handleOpenFile || $[27] !== handleSend || $[28] !== t3 || $[29] !== t4) {
    t5 = {
      agentName,
      started: conversa.started,
      situation: conversa.situation,
      messages: conversa.messages,
      cleared: conversa.cleared,
      answeredMessageIds: conversa.answeredMessageIds,
      activeInteractionId: conversa.activeInteractionId,
      inputEnabled: conversa.inputEnabled,
      sending: conversa.sending,
      draft: conversa.draft,
      draftMaxLength: LIMITE_DO_TEXTO,
      onDraftChange: conversa.setDraft,
      onSend: handleSend,
      composerStatus: t3,
      onRetry: conversa.tentarNovamente,
      attachEnabled: t4,
      acceptedFileTypes: MIMES_ACEITOS_NO_ANEXO,
      onAttach: handleAttach,
      onReply: conversa.responder,
      unavailableFileIds: arquivos.indisponiveis,
      simulacaoId: arquivos.simulacaoId,
      onOpenFile: handleOpenFile,
      onFileUnavailable: arquivos.marcarIndisponivel,
      typing: conversa.typing,
      superficie: arquivos.superficie
    };
    $[7] = agentName;
    $[8] = arquivos.indisponiveis;
    $[9] = arquivos.marcarIndisponivel;
    $[10] = arquivos.simulacaoId;
    $[11] = arquivos.superficie;
    $[12] = conversa.activeInteractionId;
    $[13] = conversa.answeredMessageIds;
    $[14] = conversa.cleared;
    $[15] = conversa.draft;
    $[16] = conversa.inputEnabled;
    $[17] = conversa.messages;
    $[18] = conversa.responder;
    $[19] = conversa.sending;
    $[20] = conversa.setDraft;
    $[21] = conversa.situation;
    $[22] = conversa.started;
    $[23] = conversa.tentarNovamente;
    $[24] = conversa.typing;
    $[25] = handleAttach;
    $[26] = handleOpenFile;
    $[27] = handleSend;
    $[28] = t3;
    $[29] = t4;
    $[30] = t5;
  } else {
    t5 = $[30];
  }
  const chat = t5;
  let t6;
  if ($[31] !== arquivos.indisponiveis || $[32] !== conversa) {
    t6 = formato => void conversa.baixar(formato, arquivos.indisponiveis);
    $[31] = arquivos.indisponiveis;
    $[32] = conversa;
    $[33] = t6;
  } else {
    t6 = $[33];
  }
  let t7;
  if ($[34] !== chat || $[35] !== conversa || $[36] !== t6) {
    t7 = {
      conversa,
      chat,
      baixar: t6
    };
    $[34] = chat;
    $[35] = conversa;
    $[36] = t6;
    $[37] = t7;
  } else {
    t7 = $[37];
  }
  return t7;
}